import clsx from "clsx";

import { TextTooltip } from "@transfr-inc/dashboard-components";

import { formatDateSlashes } from "@src/utils/utils";

import "./integration-date.scss";

const IntegrationDate = ({ date, error = false }) => {
  return (
    <div className={clsx("integration-date", error && "error")}>
      <TextTooltip text="UTC">{formatDateSlashes(date)}</TextTooltip>
    </div>
  );
};

export default IntegrationDate;
